import { Navigate, Route, Routes } from "react-router-dom";
import { Home } from "./home";
import { ListeClimatisseurs } from "./listeClimatisseurs";
import { ListeProjets } from "./listeProjets";
import { Contact } from "./contact";
import { InfoClimatisseur } from "./infoClimatisseur";
import { InfoProjet } from "./infoProjet";
import { Login } from "./login";
import { Panier } from "./panier";
import { ValidationCommande } from "./validationCommande";
import { Paiement } from "./paiement";
import { PageClimatisseurs } from "./pageClimatisseurs";
import { PageProjets } from "./pageProjets";
import { PageComptes } from "./pageComptes";
import { DashbordPage } from "./dashbordPage";
import { CategorieClimatisseurs } from "./categorieClimatisseurs";
import { CategorieProjets } from "./categorieProjets";
import { PageCommandes } from "./pageCommandes";
import { PageCommentaires } from "./pageCommentaires";
import { AjouterCommantaire } from "./ajouterCommantaire";
import { AdminFormClimatiseur } from "./adminFormClimatiseur";
import { AdminFormProjet } from "./adminFormProjet";
import { PageHistorique } from "./pageHistorique";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getDataClimats, getDataProjets, getDataComptes, getDataCommandes, getPanier } from "./action";

export function App() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getDataClimats());
        dispatch(getDataProjets());
        dispatch(getDataComptes());
        dispatch(getDataCommandes());
        dispatch(getPanier());
    }, [dispatch]);

    return <div>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/listeClimatisseurs" element={<ListeClimatisseurs />} />
            <Route path="/listeClimatisseurs/:id" element={<InfoClimatisseur />} />
            <Route path="/infoClimatisseur/:id" element={<InfoClimatisseur />} />
            <Route path="/categorieClimatisseurs/:genreClimatisseur" element={<CategorieClimatisseurs />} />
            <Route path="/panier" element={<Panier />} />
            <Route path="/valider" element={<ValidationCommande />} />
            <Route path="/paiement" element={<Paiement />} />
            <Route path="/ajouterCommantaire/:id" element={<AjouterCommantaire />} />
            <Route path="/listeProjets" element={<ListeProjets />} />
            <Route path="/listeProjets/:id" element={<InfoProjet />} />
            <Route path="/categorieProjets/:ville" element={<CategorieProjets />} />
            <Route path="/dashbordPage" element={<DashbordPage />} />
            <Route path="/pageHistorique" element={<PageHistorique />} />
            <Route path="/pageClimatisseurs" element={<PageClimatisseurs />} />
            <Route path="/pageProjets" element={<PageProjets />} />
            <Route path="/pageComptes" element={<PageComptes />} />
            <Route path="/pageCommandes" element={<PageCommandes />} />
            <Route path="/pageCommentaires" element={<PageCommentaires />} />
            <Route path="/admin-climatisseur/add" element={<AdminFormClimatiseur />} />
            <Route path="/admin-climatisseur/ajouter" element={<AdminFormClimatiseur />} />
            <Route path="/admin-climatisseur/edit/:id" element={<AdminFormClimatiseur />} />
            <Route path="/admin-projet/add" element={<AdminFormProjet />} />
            <Route path="/admin-projet/ajouter" element={<AdminFormProjet />} />
            <Route path="/admin-projet/edit/:id" element={<AdminFormProjet />} />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    </div>
}